import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import DashboardRoleTableService from '../service/DashboardRoleTableService';

const config = {
	key: 'dashboardRoleTable',
	topic: 'user',
	service: DashboardRoleTableService,
	defaultRowsPerPage: 100,
	editFormState: item => `/dashboard-role/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'title'
		},
		{
			key: 'adminDescription'
		},
		{
			key: 'isEnabled',
			type: 'boolean'
		},
		{
			key: 'created',
			type: 'dateTime'
		},
		{
			key: 'updated',
			type: 'dateTime'
		}
	]
};

function DashboardRoleTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('dashboardRoleTable', reducer('dashboardRoleTable'))(DashboardRoleTable);
